import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Cookie, Check, X } from "lucide-react";

const CookiesPage = () => {
  const cookies = [
    { name: "_verasist_session", purpose: "Oturum yönetimi ve kimlik doğrulama", duration: "Oturum süresi", required: true },
    { name: "_verasist_lang", purpose: "Dil tercihinizi hatırlar (TR/EN)", duration: "1 yıl", required: false },
    { name: "_verasist_theme", purpose: "Tema tercihinizi hatırlar (açık/koyu)", duration: "1 yıl", required: false },
    { name: "_ga / _ga_*", purpose: "Google Analytics - ziyaretçi istatistikleri", duration: "2 yıl", required: false },
    { name: "_fbp", purpose: "Meta (Facebook) piksel - pazarlama", duration: "90 gün", required: false },
    { name: "_hjSession_*", purpose: "Hotjar - kullanıcı davranış analizi", duration: "30 dakika", required: false },
    { name: "intercom-*", purpose: "Intercom - canlı destek sohbeti", duration: "1 yıl", required: false },
  ];

  const hero = (
    <PageHero
      eyebrow="Yasal"
      title="Çerez Politikası"
      subtitle="Web sitemizde ve platformumuzda hangi çerezleri, hangi amaçlarla kullandığımızı şeffaf bir şekilde açıklıyoruz."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/blog/cybersecurity.jpg" alt="Veri güvenliği" height="300px" />
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-10 text-[14.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.88 }}>
              <div>
                <h2 className="text-[22px] font-bold mb-4" style={{ color: "var(--fg)" }}>Çerez Nedir?</h2>
                <p>Çerezler (cookies), ziyaret ettiğiniz web siteleri tarafından tarayıcınıza kaydedilen küçük metin dosyalarıdır. Tercihlerinizi hatırlamak, site performansını ölçmek ve size daha iyi bir deneyim sunmak için kullanılırlar.</p>
              </div>

              <div>
                <h2 className="text-[22px] font-bold mb-4" style={{ color: "var(--fg)" }}>Kullandığımız Çerezler</h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-left" style={{ borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: "1px solid var(--border)" }}>
                        <th className="py-3 pr-4 text-[13px] font-semibold" style={{ color: "var(--fg)" }}>Çerez</th>
                        <th className="py-3 pr-4 text-[13px] font-semibold" style={{ color: "var(--fg)" }}>Amaç</th>
                        <th className="py-3 pr-4 text-[13px] font-semibold" style={{ color: "var(--fg)" }}>Süre</th>
                        <th className="py-3 text-[13px] font-semibold" style={{ color: "var(--fg)" }}>Zorunlu</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cookies.map((c) => (
                        <tr key={c.name} style={{ borderBottom: "1px solid var(--border)" }}>
                          <td className="py-3 pr-4">
                            <code className="text-[12.5px] px-1.5 py-0.5 rounded" style={{ background: "var(--bg)", color: "var(--brand-cyan)" }}>{c.name}</code>
                          </td>
                          <td className="py-3 pr-4 text-[13px]">{c.purpose}</td>
                          <td className="py-3 pr-4 text-[13px]">{c.duration}</td>
                          <td className="py-3">
                            {c.required ? (
                              <span className="inline-flex items-center gap-1 text-[12px]" style={{ color: "#10b981" }}><Check size={14} /> Zorunlu</span>
                            ) : (
                              <span className="inline-flex items-center gap-1 text-[12px]" style={{ color: "var(--muted)" }}><X size={14} /> İsteğe bağlı</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <h2 className="text-[22px] font-bold mb-4" style={{ color: "var(--fg)" }}>Çerezleri Nasıl Yönetirsiniz?</h2>
                <p className="mb-3">Tarayıcı ayarlarınızdan tüm çerezleri engelleyebilir veya silebilirsiniz. Ancak zorunlu çerezlerin engellenmesi, platformun bazı özelliklerinin düzgün çalışmamasına neden olabilir.</p>
                <p>Sitemizi ilk ziyaretinizde gösterilen çerez banner'ı üzerinden isteğe bağlı çerezleri yönetebilirsiniz. Tarayıcı bazında çerez yönetimi için:</p>
                <ul className="space-y-1 mt-3 list-disc pl-5">
                  <li><strong>Chrome:</strong> Ayarlar → Gizlilik ve Güvenlik → Çerezler</li>
                  <li><strong>Firefox:</strong> Tercihler → Gizlilik ve Güvenlik → Çerezler</li>
                  <li><strong>Safari:</strong> Tercihler → Gizlilik → Çerezler</li>
                  <li><strong>Edge:</strong> Ayarlar → Çerezler ve Site İzinleri</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[22px] font-bold mb-4" style={{ color: "var(--fg)" }}>İletişim</h2>
                <p>Çerez politikamız hakkında sorularınız için: <a href="mailto:kvkk@verasist.ai" style={{ color: "var(--brand-cyan)" }}>kvkk@verasist.ai</a></p>
              </div>
            </div>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default CookiesPage;
